<template>
    <CardPage :section="20" :page="6">
        <p>Well, you’ve made it to the end of the house challenges! I’m so proud of you, {{ name }}. Let’s review what you’ve learned:</p>
        <ul>
            <li>
                You learned about our trans history. So many amazing trans folks have paved the way for you, and you are paving the way for so many young people
                who will come after you!
            </li>
            <li>
                You learned how to break down barriers by using assertive communication with your friends, partners, and health care providers. You can use
                those skills in other situations, too!
            </li>
            <li>You learned a lot about trans health, HIV/STIs, and how to inject hormones safely.</li>
            <li>You learned how to protect yourself by setting boundaries, because you are worth protecting!</li>
        </ul>
        <ResponsiveImage
            :src="require('@/assets/poses/Trans-Poses_0003_Queenie_talking.png')"
            alt="Queenie"
            layout="align-center justify-end mt-3"
            flex="xs4"
        ></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        name: get('preferences@name')
    }
};
</script>
